var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.5,
    r: 8,
    fill: "#F7F7F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3C4.9625 3 2.5 5.4625 2.5 8.5C2.5 11.5375 4.9625 14 8 14C11.0375 14 13.5 11.5375 13.5 8.5C13.5 5.4625 11.0375 3 8 3ZM10.384 7.57C10.4279 7.51982 10.4613 7.46137 10.4823 7.39808C10.5033 7.3348 10.5114 7.26796 10.5061 7.20149C10.5009 7.13503 10.4824 7.07028 10.4518 7.01106C10.4212 6.95185 10.379 6.89935 10.3278 6.85667C10.2766 6.81399 10.2173 6.78198 10.1535 6.76253C10.0898 6.74308 10.0228 6.73658 9.95644 6.74341C9.89012 6.75025 9.82584 6.77027 9.76737 6.80232C9.70891 6.83436 9.65744 6.87777 9.616 6.93L7.466 9.5095L6.3535 8.3965C6.2592 8.30542 6.1329 8.25502 6.0018 8.25616C5.8707 8.2573 5.74529 8.30989 5.65259 8.40259C5.55989 8.49529 5.5073 8.6207 5.50616 8.7518C5.50502 8.8829 5.55542 9.0092 5.6465 9.1035L7.1465 10.6035C7.19563 10.6526 7.25445 10.6909 7.31921 10.716C7.38397 10.7411 7.45325 10.7525 7.52263 10.7493C7.59202 10.7462 7.65999 10.7286 7.72221 10.6977C7.78442 10.6668 7.83953 10.6234 7.884 10.57L10.384 7.57Z",
    fill: "#D8D8DD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/all.4346e869ec6d34eb9edd9402ec2385a7.svg";
export { ForwardRef as ReactComponent };